import { EERIE } from 'HubStyleTokens/colors';
export const IMAGE_TYPES = {
  IMAGE: 'IMAGE',
  ICON: 'ICON'
};
export const DEFAULT_ICON_COLOR = EERIE;
export const TEMPLATE_TYPE = {
  // modal settings to be displayed by template
  CARDS: 'cards',
  // icon/image: no, color: yes, articles: no
  CONTENT: 'content_rich',
  // icon/image: yes, color: yes, articles: yes
  DEFAULT: 'classic',
  // icon/image no, color: no, articles: no, clicking on categories disabled
  MINIMAL: 'minimal',
  // icon/image: yes, color: yes, articles: no
  TILES: 'tiles' // icon/image: yes, color: yes, articles: no
};